(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const headerDetails = document.querySelector(".menu-drawer-container");
		const headerIsAlwaysSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "always";

		headerDetails.addEventListener("toggle", function (e) {
			const colorScheme =
				this.querySelector("#menu-drawer").dataset.colorScheme;
			header.classList.toggle(colorScheme);
		});

		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				header.classList.remove("shopify-section-header-sticky", "animate");
				body.classList.remove("overflow-hidden");
			}
		});

		document.addEventListener("scroll", () => {
			let scrollTop = window.scrollY;
			if (scrollTop > header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.add("fixed", "animate");
			} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.remove("fixed", "animate");
			}
		});

		const addBackground = () => {
			if (
				header.classList.contains("color-inverse") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.remove("color-inverse");
			}
		};

		const removeBackground = () => {
			if (document.body.classList.contains("overflow-hidden-tablet")) {
				return;
			}

			if (
				header.classList.contains("header-overlay") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.add("color-inverse");
			}
		};

		header.addEventListener("mouseenter", addBackground);

		header.addEventListener("focus", addBackground);

		header.addEventListener("focusin", addBackground);

		header.addEventListener("mouseleave", removeBackground);

		header.addEventListener("focusout", removeBackground);
	};

	header();

	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);
})();

/* JOCQUELINE desktop burger drawer category promo cards */
(function () {
	const normalizeText = (value) =>
		(value || "").replace(/\s+/g, " ").trim().toLowerCase();

	const findMenuHref = (title) => {
		const target = normalizeText(title);
		const links = document.querySelectorAll(".burger-drawer .drawer__left a");
		for (const link of links) {
			if (normalizeText(link.textContent) === target) {
				return link.getAttribute("href") || "#";
			}
		}
		return "#";
	};

	const prepareCard = (sourceCard, title) => {
		const card = sourceCard.cloneNode(true);
		const promoText = card.querySelector(".promo_text");
		if (promoText) {
			promoText.replaceChildren();
			const heading = document.createElement("h5");
			heading.textContent = title;
			promoText.appendChild(heading);
		}

		const image = card.querySelector("img");
		if (image) image.setAttribute("alt", title);

		const overlayLink = card.querySelector(".drawer__collection-link-overlay");
		const href = findMenuHref(title);
		if (overlayLink) {
			overlayLink.setAttribute("aria-label", title);
			if (href && href !== "#") {
				overlayLink.setAttribute("href", href);
				overlayLink.removeAttribute("aria-disabled");
			} else {
				overlayLink.setAttribute("href", "#");
				overlayLink.setAttribute("aria-disabled", "true");
			}
		}
		return card;
	};

	const applyCategoryPromos = () => {
		const rightPanel = document.querySelector(".burger-drawer .drawer__right");
		if (!rightPanel || rightPanel.dataset.jocquelineCategoryPromos === "applied") return;

		const originalCards = Array.from(
			rightPanel.querySelectorAll(".drawer__collection-block")
		);
		if (originalCards.length < 3) return;

		const bags = prepareCard(originalCards[2], "Bags");
		const iphoneCases = prepareCard(originalCards[0], "iPhone Cases");
		const smallLeatherGoods = prepareCard(originalCards[1], "Small Leather Goods");
		const techGoods = prepareCard(originalCards[1], "Tech Goods");

		rightPanel.replaceChildren(
			bags,
			iphoneCases,
			smallLeatherGoods,
			techGoods
		);
		rightPanel.dataset.jocquelineCategoryPromos = "applied";
	};

	applyCategoryPromos();
	document.addEventListener("shopify:section:load", () =>
		requestAnimationFrame(applyCategoryPromos)
	);
	document.addEventListener("shopify:section:reorder", () =>
		requestAnimationFrame(applyCategoryPromos)
	);
})();
